/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserModerationsModeratorControllerModerateMutationRequest,
  UserModerationsModeratorControllerModerateMutationResponse,
  UserModerationsModeratorControllerModerate401,
  UserModerationsModeratorControllerModerate404,
} from '../types/UserModerationsModeratorControllerModerate.ts';

function getUserModerationsModeratorModerateUrl() {
  const res = { method: 'PATCH', url: `/api/moderator/user-moderations/moderate` as const };
  return res;
}

/**
 * {@link /api/moderator/user-moderations/moderate}
 */
export async function userModerationsModeratorModerate(
  data: UserModerationsModeratorControllerModerateMutationRequest,
  config: Partial<RequestConfig<UserModerationsModeratorControllerModerateMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    UserModerationsModeratorControllerModerateMutationResponse,
    ResponseErrorConfig<UserModerationsModeratorControllerModerate401 | UserModerationsModeratorControllerModerate404>,
    UserModerationsModeratorControllerModerateMutationRequest
  >({
    method: 'PATCH',
    url: getUserModerationsModeratorModerateUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
